export default function ItemBody({ body }: { body: string }) {
  return (
    <div
      className='prose prose-invert item-prose'
      dangerouslySetInnerHTML={{ __html: body }}
    ></div>
  );
}
